'use client';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowRight, Lightbulb } from 'lucide-react';
import { useState } from 'react';

const suggestions = [
  {
    title: 'Re-engage lapsed members',
    description: 'Send re-engagement email to 273 lapsed members',
    action: 'Create Campaign',
  },
  {
    title: 'Unredeemed offers',
    description: "You have 143 customers who didn't redeem their offer",
    action: 'Send Reminder',
  },
  {
    title: 'Top customer attention',
    description: "Top customers haven't been messaged in 7 days",
    action: 'Create Segment',
  },
];

export function SmartSuggestionsPanel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSuggestion = () => {
    setCurrentIndex(prev => (prev + 1) % suggestions.length);
  };

  const currentSuggestion = suggestions[currentIndex];

  return (
    <Card className='h-[320px] flex flex-col shadow-none'>
      <CardHeader className='flex flex-row items-center gap-2'>
        <Lightbulb className='h-5 w-5 text-amber-500' />
        <div>
          <CardTitle>Smart Suggestions</CardTitle>
          <CardDescription className='text-md'>
            Recommended actions to boost your business
          </CardDescription>
        </div>
      </CardHeader>
      <CardContent className='flex flex-col flex-1 justify-between py-4'>
        <div className='space-y-2 flex-grow'>
          <h3 className='font-medium'>{currentSuggestion.title}</h3>
          <p className='text-md text-muted-foreground'>
            {currentSuggestion.description}
          </p>
        </div>
        <div className='flex flex-col sm:flex-row gap-3 mt-auto pt-4 w-full'>
          <Button
            variant='outline'
            className='h-10 px-4 justify-center shrink-0'
            onClick={nextSuggestion}
          >
            Next tip
          </Button>
          <Button
            variant='secondary'
            className='text-white h-10 px-4 justify-center sm:flex-1 truncate max-w-full'
          >
            <span className='truncate'>{currentSuggestion.action}</span>
            <ArrowRight className='ml-2 h-4 w-4 shrink-0' />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
